import { RecognitionArtifactComponentFragmentFragment } from "types/graphql-schema";

import useLabel from "@apps/use-label/use-label";
import Avatar from "@components/avatar/avatar";
import Avatars from "@components/avatar/avatars";
import { assertEdgesNonNull } from "@helpers/helpers";

const ArtifactRecognitionRecipients = ({
  artifact,
}: {
  artifact: RecognitionArtifactComponentFragmentFragment;
}) => {
  const label = useLabel();

  const recipients = artifact.recipients
    ? assertEdgesNonNull(artifact.recipients)
    : [];
  // 20x20 affordance with 16x16 avatar inside — matches the small icon-button
  // styling used by the other right-side artifact controls.
  if (artifact.recipients?.totalCount === 1) {
    return (
      <span className="flex items-center justify-center w-5 h-5 rounded-md hover:bg-black/5">
        <Avatar
          user={recipients[0]}
          size="4"
          tooltipSuffix={` received a ${label("recognition")}`}
        />
      </span>
    );
  }
  if ((artifact.recipients?.totalCount || 0) > 1) {
    return (
      <Avatars max={4} users={recipients} size={4} modalTitle="Recipients" />
    );
  }
  return null;
};

export default ArtifactRecognitionRecipients;
